"use strict";
var core_1 = require('@angular/core');
var VgStates = (function () {
    function VgStates() {
    }
    VgStates.VG_ENDED = 'ended';
    VgStates.VG_PAUSED = 'paused';
    VgStates.VG_PLAYING = 'playing';
    VgStates.VG_LOADING = 'waiting';
    VgStates.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    VgStates.ctorParameters = [];
    return VgStates;
}());
exports.VgStates = VgStates;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmctc3RhdGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidmctc3RhdGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxxQkFBeUIsZUFBZSxDQUFDLENBQUE7QUFHekM7SUFBQTtJQVdBLENBQUM7SUFWVSxpQkFBUSxHQUFXLE9BQU8sQ0FBQztJQUMzQixrQkFBUyxHQUFXLFFBQVEsQ0FBQztJQUM3QixtQkFBVSxHQUFXLFNBQVMsQ0FBQztJQUMvQixtQkFBVSxHQUFXLFNBQVMsQ0FBQztJQUNuQyxtQkFBVSxHQUEwQjtRQUMzQyxFQUFFLElBQUksRUFBRSxpQkFBVSxFQUFFO0tBQ25CLENBQUM7SUFDRixrQkFBa0I7SUFDWCx1QkFBYyxHQUE2RCxFQUNqRixDQUFDO0lBQ0YsZUFBQztBQUFELENBQUMsQUFYRCxJQVdDO0FBWFksZ0JBQVEsV0FXcEIsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7SW5qZWN0YWJsZX0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG5cblxuZXhwb3J0IGNsYXNzIFZnU3RhdGVzIHtcbiAgICBzdGF0aWMgVkdfRU5ERUQ6IHN0cmluZyA9ICdlbmRlZCc7XG4gICAgc3RhdGljIFZHX1BBVVNFRDogc3RyaW5nID0gJ3BhdXNlZCc7XG4gICAgc3RhdGljIFZHX1BMQVlJTkc6IHN0cmluZyA9ICdwbGF5aW5nJztcbiAgICBzdGF0aWMgVkdfTE9BRElORzogc3RyaW5nID0gJ3dhaXRpbmcnO1xuc3RhdGljIGRlY29yYXRvcnM6IERlY29yYXRvckludm9jYXRpb25bXSA9IFtcbnsgdHlwZTogSW5qZWN0YWJsZSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuc3RhdGljIGN0b3JQYXJhbWV0ZXJzOiAoe3R5cGU6IGFueSwgZGVjb3JhdG9ycz86IERlY29yYXRvckludm9jYXRpb25bXX18bnVsbClbXSA9IFtcbl07XG59XG5cbmludGVyZmFjZSBEZWNvcmF0b3JJbnZvY2F0aW9uIHtcbiAgdHlwZTogRnVuY3Rpb247XG4gIGFyZ3M/OiBhbnlbXTtcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/videogular2/src/core/states/vg-states.js
// module id = 84
// module chunks = 3